import * as ROUTES from '#client/constants/routes';

export function buildVeloPageUrl(businessEntityUuid, { promptSet, origination }) {
  const params = new URLSearchParams({ promptSet, origination });

  return `${ROUTES.VELO_GUIDE_COMPANY.replace('[businessEntityUuid]', businessEntityUuid)}/?${params.toString()}`;
}
